// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Shared design tokens: wireframe button style */
:root {
  --surface-bg: #2d2d2d;
  --panel-bg: #232323;
  --btn-bg: #232323;
  --btn-bg-hover: #1f1f1f;
  --wire-purple: #c9a8ff;
  --wire-green: #a5f3b0;
  --wire-blue: #a8d8ff;
  --wire-peach: #ffd9a8;
  --wire-teal: #a8f0f7;
  --wire-red: #ffb3ba;
}

body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  line-height: 1.6;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

/* Global responsive utilities */
@media (max-width: 768px) {
  body {
    font-size: 14px;
  }
}

@media (max-width: 480px) {
  body {
    font-size: 12px;
  }
}

@media (min-width: 1200px) {
  body {
    font-size: 16px;
  }
}

/* Ensure proper box-sizing */
*, *::before, *::after {
  box-sizing: border-box;
}

/* Improve touch targets on mobile */
@media (max-width: 768px) {
  button, .vault-add-button, input, select {
    min-height: 44px;
    min-width: 44px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,iDAAiD;AACjD;EACE,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB,oBAAoB;EACpB,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE;aACW;AACb;;AAEA,gCAAgC;AAChC;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA,6BAA6B;AAC7B;EACE,sBAAsB;AACxB;;AAEA,oCAAoC;AACpC;EACE;IACE,gBAAgB;IAChB,eAAe;EACjB;AACF","sourcesContent":["/* Shared design tokens: wireframe button style */\n:root {\n  --surface-bg: #2d2d2d;\n  --panel-bg: #232323;\n  --btn-bg: #232323;\n  --btn-bg-hover: #1f1f1f;\n  --wire-purple: #c9a8ff;\n  --wire-green: #a5f3b0;\n  --wire-blue: #a8d8ff;\n  --wire-peach: #ffd9a8;\n  --wire-teal: #a8f0f7;\n  --wire-red: #ffb3ba;\n}\n\nbody {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  line-height: 1.6;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n/* Global responsive utilities */\n@media (max-width: 768px) {\n  body {\n    font-size: 14px;\n  }\n}\n\n@media (max-width: 480px) {\n  body {\n    font-size: 12px;\n  }\n}\n\n@media (min-width: 1200px) {\n  body {\n    font-size: 16px;\n  }\n}\n\n/* Ensure proper box-sizing */\n*, *::before, *::after {\n  box-sizing: border-box;\n}\n\n/* Improve touch targets on mobile */\n@media (max-width: 768px) {\n  button, .vault-add-button, input, select {\n    min-height: 44px;\n    min-width: 44px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
